import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../../config/config";
import "./EditPage.css";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import LeftPanel from "../../components/LeftPanel";
const EditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const recordId = params.get("recordId");
  const videoUrl = params.get('videoUrl');
  // --------------------- State --------------------- //
  const [activeTab, setActiveTab] = useState("Media");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const PEXELS_KEY = process.env.REACT_APP_PEXELS_KEY;
const SERVER_KEY = process.env.REACT_APP_SERVER_KEY;

  const [mediaList, setMediaList] = useState([]);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
const [pexelsType, setPexelsType] = useState("video"); // "video" | "image"

  const [narratorPoints, setNarratorPoints] = useState([]);
  const [voiceOver, setVoiceOver] = useState("no voice"); 
  const [category, setCategory] = useState("");
  const [duration, setDuration] = useState("");
  const [size, setSize] = useState("");
const [music, setMusic] = useState("");                 // system selected
const [uploadedMusic, setUploadedMusic] = useState(null); // File object
const [uploadedMusicId, setUploadedMusicId] = useState(""); // returned from API
const [musicType, setMusicType] = useState("system");
const [musicUploaded, setMusicUploaded] = useState(false);
  const [font, setFont] = useState("");
  const [fontColor, setFontColor] = useState("#FFFFFF");
  const [textStyle, setTextStyle] = useState("Default");
  const [styleColor, setStyleColor] = useState("Black");
const [useCustomFont, setUseCustomFont] = useState(false);

  const [showPexelsModal, setShowPexelsModal] = useState(false);
  const [pexelsQuery, setPexelsQuery] = useState("");
  const [pexelsResults, setPexelsResults] = useState([]);
  const [pexelsLoading, setPexelsLoading] = useState(false);
  const selectedPexelsRef = useRef(null);

const [showAIModal, setShowAIModal] = useState(false);
const [aiPrompt, setAiPrompt] = useState("");
const [aiError, setAiError] = useState("");
const [aiPreviewUrl, setAiPreviewUrl] = useState(null);
const [aiLoading, setAiLoading] = useState(false);
const [selectedPexelsItem, setSelectedPexelsItem] = useState(null);
const [transitionStyle, setTransitionStyle] = useState("default");
const transitionOptions = [
  { label: "Default (Auto)", value: "default" },
  { label: "Fade", value: "fade" },
  { label: "Slide Left", value: "slideleft" },
  { label: "Slide Right", value: "slideright" },
  { label: "Circle Open", value: "circleopen" }
];


  const songList = [
    { name: "Synthwave goose-blade runner 2049", file: "Synthwavegoose-bladerunner2049.mp3" },
    { name: "Not Responsible (Slowed)", file: "NotResponsible(Slowed).mp3" },
    { name: "FrankJavCee - Simpsonwave 1995", file: "FrankJavCee-Simpsonwave1995.mp3" },
    { name: "INTERWORLD - METAMORPHOSIS", file: "INTERWORLD-METAMORPHOSIS.mp3" },
    { name: "WINDOWS 95", file: "WINDOWS95.mp3" },
  ];



  const colorOptions = ["Black", "White", "Red", "Green", "Blue", "Yellow", "Cyan", "Magenta", "Gray", "Orange"];
  const stylesWithColor = new Set(["Text With Border", "Text Inside Dark Box", "Text Inside Light Box"]);

  // --------------------- SAFELY PARSE MEDIA LIST --------------------- //
  function safeParseMediaList(input) {
    if (Array.isArray(input)) return input;
    if (!input) return [];
    if (typeof input === "string") {
      try {
        return JSON.parse(input);
      } catch {
        return [];
      }
    }
    return [];
  }

  // --------------------- Fetch video details --------------------- //
useEffect(() => {
  let isActive = true;

  async function loadDetails() {
    try {
      const res = await fetch(
        `${config.baseURL}/generation/get_video_details.php`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: recordId }),
        }
      );

      const json = await res.json();

      if (json.status !== "success") {
        if (json.message === "Video has already been edited") {
          toast.info("This video has already been edited.");

          setTimeout(() => {
            navigate(`/result?recordId=${recordId}`, { replace: true });
          }, 800);

          return;
        }

        throw new Error(json.message || "Fetch failed");
      }

      if (!isActive) return;

      const data = json.data;

      setMediaList(data.video_urls || []);
      setNarratorPoints(data.narrator_text || []);
      setVoiceOver(data.voice_over || "no voice");
      setCategory(data.category || "");
      setDuration(data.duration || "");
      setSize(data.size || "");
      console.log("API size:", data.size);
      setMusic(data.music || "");
      setMusicType(data.music_type || "system");
      setTransitionStyle(data.transition_style || "default");

      // 🔴 Restore uploaded music if user music was used
      if (data.music_type === "user") {
        setUploadedMusicId(data.music);
      }

   
      setUseCustomFont(data.font === "yes" || data.font === true);
      setFontColor(data.font_color || "#FFFFFF");
      setTextStyle(data.text_style || "Default");
      setStyleColor(data.style_color || "Black");

    } catch (err) {
      if (isActive) setError(err.message);
    } finally {
      if (isActive) setLoading(false);
    }
  }

  loadDetails();
  return () => { isActive = false; };

}, [recordId, navigate]);


async function uploadMusic(file) {
  setLoading(true);

  if (!file) {
    toast.error("Please select a music file first");
    setLoading(false);
    return;
  }

  const formData = new FormData();
  formData.append("music", file);

  try {
    const res = await fetch(`${config.baseURL}/generation/music_upload.php`, {
      method: "POST",
      body: formData,
      credentials: "include",
    });

    // If backend returns HTTP 400, show file type/size error
    if (res.status === 400) {
      toast.error("Please check file type and size (MP3 / Max 20MB)");
      setLoading(false);
      return;
    }

    const json = await res.json();

    if (!res.ok || json.status !== "success") {
      toast.error(json.message || "Music upload failed");
      setLoading(false);
      return;
    }

    // Expected API response:
    // {
    //   status: "success",
    //   music_id: 123,
    //   music_type: "user"
    // }

    setUploadedMusicId(json.music_id);
    setMusic(json.music_id);
    setMusicType(json.music_type);

    toast.success("Music uploaded successfully!");
    setLoading(false);

  } catch (err) {
    console.error(err);
    toast.error("Music upload error");
    setLoading(false);
  }
}




const mediaRefs = useRef([]);
const openFullscreen = (el) => {
  if (!el) return;

  if (el.requestFullscreen) el.requestFullscreen();
  else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
  else if (el.msRequestFullscreen) el.msRequestFullscreen();
};

const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
};



  // --------------------- Tab Logic --------------------- //
  const renderTab = () => {
    switch (activeTab) {
      case "Media": return renderMediaTab();
      case "Music": return renderMusicTab();
      case "Script": return renderScriptTab();
      case "Settings": return renderSettingsTab();
      default: return null;
    }
  };
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    },
    {
      root: document.querySelector(".media-scroll"),
      threshold: 0.4,
    }
  );

  mediaRefs.current.forEach((el) => {
    if (el && el.tagName === "VIDEO") observer.observe(el);
  });

  return () => observer.disconnect();
}, [mediaList]);

const MAX_SIZE = 10 * 1024 * 1024; // 10MB

const handleMediaUpload = (e) => {
  if (!size) {
    toast.error("Please wait, project is still loading");
    return;
  }

  const file = e.target.files[0];
  if (!file) return;

  // -------- FILE TYPE --------
  const isVideo = file.type === "video/mp4";
  const isImage = file.type.startsWith("image/");

  if (!isVideo && !isImage) {
    toast.error("Only MP4 video or image allowed");
    return;
  }

  // -------- FILE SIZE --------
  if (file.size > MAX_SIZE) {
    toast.error("File must be less than 10MB");
    return;
  }

  // -------- RESOLUTION CHECK --------
  validateResolution(file, isVideo);
};


// ---------------- UPLOAD TO SERVER ----------------
const uploadMediaToServer = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    setLoading(true);

    const res = await fetch("https://theserverdev.in/api/upload/media", {
      method: "POST",
      headers: {
        Authorization: SERVER_KEY,
      },
      body: formData,
    });

    const data = await res.json();

    if (!res.ok || data.status !== "success") {
      throw new Error(data.message || "Upload failed");
    }

    return data.url;

  } catch (err) {
    console.error(err);
    toast.error("Media upload failed");
    return null;
  } finally {
    setLoading(false);
  }
};


// ---------------- VALIDATE RESOLUTION ----------------
const validateResolution = (file, isVideo) => {
  const url = URL.createObjectURL(file);

  if (isVideo) {
    const video = document.createElement("video");

    video.onloadedmetadata = () => {
      checkDimensions(video.videoWidth, video.videoHeight, file);
      URL.revokeObjectURL(url);
    };

    video.src = url;
  } else {
    const img = new Image();

    img.onload = () => {
      checkDimensions(img.width, img.height, file);
      URL.revokeObjectURL(url);
    };

    img.src = url;
  }
};


// ---------------- FINAL CHECK + UPLOAD ----------------
const checkDimensions = async (width, height, file) => {
  if (!size) {
    toast.error("Project size not defined");
    return;
  }

  const [targetW, targetH] = size.split(":").map(Number);

  const uploadedRatio = width / height;
  const targetRatio = targetW / targetH;

  // 🔥 Increased tolerance (was 0.02 → now safer)
  const TOLERANCE = 0.08;

  const ratioDiff = Math.abs(uploadedRatio - targetRatio);

  // ✅ More forgiving ratio check
  const isMatchingRatio = ratioDiff <= TOLERANCE;

  // ✅ Smarter orientation check (handles near-square edge cases)
  const isLandscapeTarget = targetW > targetH;
  const isLandscapeUpload = width >= height;

  const isCorrectOrientation =
    (isLandscapeTarget && isLandscapeUpload) ||
    (!isLandscapeTarget && !isLandscapeUpload);

  // 🔍 Debug (very useful in prod logs)
  console.log({
    uploaded: `${width}x${height}`,
    uploadedRatio,
    targetRatio,
    ratioDiff,
  });

  if (!isMatchingRatio || !isCorrectOrientation) {
    toast.error(
      `Media should be close to ${targetW}:${targetH} (${isLandscapeTarget ? "Landscape" : "Portrait"})`
    );
    return;
  }

  // ✅ Upload to server
  const uploadedUrl = await uploadMediaToServer(file);

  if (!uploadedUrl) return;

  replaceMedia(uploadedUrl);
};


// ---------------- REPLACE MEDIA ----------------
const replaceMedia = (mediaUrl) => {
  const updatedList = [...mediaList];
  updatedList[selectedMediaIndex] = mediaUrl;

  setMediaList(updatedList);

  toast.success("Media replaced successfully");
};
  // --------------------- Media Tab --------------------- //
// --------------------- Media Tab --------------------- //
const renderMediaTab = () => (
  <div className="tab-content">
    <div className="media-scroll">
      {mediaList.map((url, i) => {
        const isVideo = /\.(mp4|webm|mov)$/i.test(url);

        return (
        <div
  key={i}
  ref={(el) => (mediaRefs.current[i] = el)}   // ⬅️ move ref here
  className={`media-thumb ${i === selectedMediaIndex ? "selected" : ""}`}
  onClick={() => setSelectedMediaIndex(i)}
>
  {isVideo ? (
    <video
      src={url}
      muted
      loop
      autoPlay
      playsInline
      className="media-video"
    />
  ) : (
    <img src={url} alt={`media-${i}`} />
  )}

  {/* Fullscreen button */}
  <button
    className="fullscreen-btn"
    onClick={(e) => {
      e.stopPropagation();
      openFullscreen(mediaRefs.current[i]);  // fullscreen the container
    }}
  >
    ⛶
  </button>

  {/* Exit fullscreen button */}
  <button
    className="exit-fullscreen-btn"
    onClick={(e) => {
      e.stopPropagation();
      exitFullscreen();
    }}
  >
    ← Back
  </button>
</div>


        );
      })}
    </div>

    <div className="media-actions">
      <button onClick={() => setShowPexelsModal(true)}>
        Replace Stock Footage
      </button>

      <input
  type="file"
  accept="video/mp4,image/*"
  onChange={handleMediaUpload}
  style={{ display: "none" }}
  id="mediaUpload"
/>

<button
  disabled={selectedMediaIndex === null}
  onClick={() => document.getElementById("mediaUpload").click()}
>
  Upload Media
</button>
<p className="upload-policy">
  <strong>Media Upload Policy:</strong> Uploaded images and videos are inserted
  into your project as provided. Generator.video does not modify uploaded media
  using AI for face swapping, identity cloning, or deepfake generation. Only
  upload content that you own or are authorized to use.
</p>

      {/* Transition Dropdown (Placed under AI Media) */}
     <label>Select Transition Style</label>
<select
  value={transitionStyle}
  onChange={(e) => setTransitionStyle(e.target.value)}
>
  {transitionOptions.map((opt) => (
    <option key={opt.value} value={opt.value}>
      {opt.label}
    </option>
  ))}
</select>

    </div>
  </div>
);




  // --------------------- Music Tab --------------------- //
 // --------------------- Music Tab --------------------- //
const renderMusicTab = () => (
  <div className="tab-content">
    <div className="current-music">
      Current Music:{" "}
      {musicType === "system"
        ? music || "No Music"
        : uploadedMusicId || uploadedMusic?.name || "No Music"}
    </div>

    <label>Upload Music Only MP3 is allowed</label>
<input
  type="file"
  accept="audio/mpeg,.mp3"
  onChange={(e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 20 * 1024 * 1024; // 10MB

    // Check file extension as backup
    const isMp3 =
      file.type.startsWith("audio/") &&
      file.name.toLowerCase().endsWith(".mp3");

    if (!isMp3) {
      toast.error("Only MP3 files are allowed!");
      e.target.value = "";
      return;
    }

    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB!");
      e.target.value = "";
      return;
    }

    setUploadedMusic(file);
    setMusic("");
    setUploadedMusicId("");
    setMusicType("user");

    uploadMusic(file);
  }}
/>



    <h3>or</h3>

    <label>Select Music</label>
    <select
      value={music}
      onChange={(e) => {
        setMusic(e.target.value);
        setUploadedMusic(null);
        setUploadedMusicId("");
        setMusicType("system");
      }}
    >
      <option value="">-- Select from List --</option>
      {songList.map((s, idx) => (
        <option key={idx} value={s.file}>
          {s.name}
        </option>
      ))}
    </select>
  </div>
);



 // --------------------- Script Tab --------------------- //
const MAX_CHARS = 200;

const renderScriptTab = () => (
  <div className="tab-content">
    {narratorPoints.map((text, i) => (
      <div key={i} className="script-line">
        <textarea
          value={text}
          maxLength={MAX_CHARS}
          onChange={(e) => {
            const val = e.target.value;
            setNarratorPoints((prev) =>
              prev.map((p, idx) => (idx === i ? val : p))
            );
          }}
        />
        <span>{MAX_CHARS - text.length} chars left</span>
      </div>
    ))}
  </div>
);

useEffect(() => {
  const slider = document.querySelector(".font-grid");
  if (!slider) return;

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  const start = (e) => {
    isDown = true;
    slider.classList.add("dragging");
    startX = e.pageX || e.touches[0].pageX;
    scrollLeft = slider.scrollLeft;
  };

  const end = () => {
    isDown = false;
    slider.classList.remove("dragging");
  };

  const move = (e) => {
    if (!isDown) return;
    e.preventDefault();                 // only blocks while dragging
    const x = e.pageX || e.touches[0].pageX;
    const walk = (x - startX) * 1.3;
    slider.scrollLeft = scrollLeft - walk;
  };

  slider.addEventListener("mousedown", start);
  slider.addEventListener("mousemove", move);
  slider.addEventListener("mouseup", end);
  slider.addEventListener("mouseleave", end);

  slider.addEventListener("touchstart", start, { passive: false });
  slider.addEventListener("touchmove", move, { passive: false });
  slider.addEventListener("touchend", end);

  return () => {
    slider.removeEventListener("mousedown", start);
    slider.removeEventListener("mousemove", move);
    slider.removeEventListener("mouseup", end);
    slider.removeEventListener("mouseleave", end);

    slider.removeEventListener("touchstart", start);
    slider.removeEventListener("touchmove", move);
    slider.removeEventListener("touchend", end);
  };
}, []);

  // --------------------- Settings Tab --------------------- //
  const renderSettingsTab = () => (
    <div className="tab-content">
      <label>Caption</label>
                    <select
                      className="input_3"
                      name="font"
                      value={useCustomFont.toString()} 
                      onChange={(e) => setUseCustomFont(e.target.value === "true")}
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>

      <label>Select Font Color</label>
      <select className="input_3" value={fontColor} onChange={(e) => setFontColor(e.target.value)}>
        {colorOptions.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>

      <label>Select Text Style</label>
      <select className="input_3" value={textStyle} onChange={(e) => setTextStyle(e.target.value)}>
        <option value="Default">Default</option>
        <option value="Text With Border">Text With Border</option>
        <option value="Text Inside Dark Box">Text Inside Dark Box</option>
        <option value="Text Inside Light Box">Text Inside Light Box</option>
        <option value="Bulb Text">Bulb Text</option>
        <option value="Neon Text">Neon Text</option>
      </select>

      {stylesWithColor.has(textStyle) && (
        <>
          <label>Select Style Color</label>
          <select  className="input_3" value={styleColor} onChange={(e) => setStyleColor(e.target.value)}>
            {colorOptions.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </>
      )}

      <label>Select Voice Over</label>
      <select className="input_3" value={voiceOver} onChange={(e) => setVoiceOver(e.target.value)}>
        <option value="no voice">No Voice</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
      </select>
    </div>
  );

  // --------------------- ORIENTATION LOGIC --------------------- //
  function getOrientation(size) {
    if (size === "9:16") return "vertical";
    if (size === "16:9") return "landscape";
    if (size === "1:1") return "square";
    return "landscape";
  }

  // --------------------- Pexels Search (Photos + Videos) --------------------- //
 async function searchPexels() {
  if (!pexelsQuery) return;

  setPexelsLoading(true);
  const orientation = getOrientation(size);

  try {
    // ================= IMAGE SEARCH =================
    if (pexelsType === "image") {
      const photosRes = await fetch(
        `https://api.pexels.com/v1/search?query=${encodeURIComponent(
          pexelsQuery
        )}&orientation=${orientation}&per_page=40`,
        {
          headers: { Authorization: PEXELS_KEY },
        }
      );

      const photosJson = await photosRes.json();

      const photoResults = (photosJson.photos || []).map((p) => {
        let img;

        if (size === "9:16") img = p.src.portrait;
        else if (size === "16:9") img = p.src.landscape;
        else if (size === "1:1") img = p.src.original;
        else img = p.src.landscape;

        return {
          id: "p-" + p.id,
          type: "image",
          url: img,
        };
      });

      setPexelsResults(photoResults);
    }

    // ================= VIDEO SEARCH =================
    if (pexelsType === "video") {
      const videosRes = await fetch(
        `https://api.pexels.com/videos/search?query=${encodeURIComponent(
          pexelsQuery
        )}&orientation=${orientation}&per_page=40`,
        {
          headers: { Authorization: PEXELS_KEY },
        }
      );

      const videosJson = await videosRes.json();

      const videoResults = (videosJson.videos || [])
        .map((v) => {
          let file;

          if (size === "9:16") {
            file = v.video_files.find((f) => f.height > f.width);
          } else if (size === "16:9") {
            file = v.video_files.find((f) => f.width > f.height);
          } else if (size === "1:1") {
            file = v.video_files.find((f) => f.width === f.height);
          } else {
            file = v.video_files[0];
          }

          if (!file) return null;

          return {
            id: "v-" + v.id,
            type: "video",
            url: file.link,
          };
        })
        .filter(Boolean);

      setPexelsResults(videoResults);
    }
  } catch (err) {
    console.error(err);
    alert("Pexels fetch failed");
  }

  setPexelsLoading(false);
}



function applyPexelsReplace() {
 if (!selectedPexelsItem) return;

  const updated = [...mediaList];
 updated[selectedMediaIndex] = selectedPexelsItem.url;


  setMediaList(updated);
  setShowPexelsModal(false);
}


function validateNarratorPoints() {
  for (let i = 0; i < narratorPoints.length; i++) {
    const text = narratorPoints[i].trim();

    // 1. Must not be empty
    if (!text) {
      toast.error(`Script line ${i + 1} cannot be empty`);
      return false;
    }

    // 2. Must contain at least 2 words
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length < 2) {
      toast.error(`Script line ${i + 1} must contain at least 2 words`);
      return false;
    }
  }
  return true;
}


 async function saveChanges() {
  setSaving(true);
  setLoading(true);

  if (musicType === "user" && !uploadedMusicId) {
    toast.error("Please wait until music upload finishes");
    setSaving(false);
    setLoading(false);
    return;
  }

   if (!validateNarratorPoints()) {
    setSaving(false);
    setLoading(false);
    return;
  }

  const finalMusic = musicType === "system" ? music : uploadedMusicId;

  const payload = {
    job_id: recordId,
    data: {
      video_urls: mediaList,
      narrator_points: narratorPoints,
      voice_over: voiceOver,
      music: finalMusic,
      music_type: musicType,   // now guaranteed correct
      transition_style: transitionStyle,
      font: useCustomFont ? "yes" : "no",
      font_color: fontColor,
      text_style: textStyle,
      style_color: styleColor,
    },
  };

  try {
    const res = await fetch(
      `${config.baseURL}/generation/update_video_details.php`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const json = await res.json();

    if (json.status !== "success") {
      throw new Error(json.message);
    }

    // ✅ start polling using recordId / job_id
    await pollStatusAfterUpdate(json.job_id);

  } catch (err) {
    alert("Save failed: " + err.message);
    setLoading(false);
  }

  setSaving(false);
}

async function pollStatusAfterUpdate(jobId) {
  const maxAttempts = 20;
  let attempts = 0;

  const delay = (ms) => new Promise((r) => setTimeout(r, ms));

  while (attempts < maxAttempts) {
    attempts++;
    console.log(`[Update Poll] Attempt ${attempts}`);

    await delay(5000); // ⏱ 30 seconds

    try {
      const res = await fetch(
        `${config.baseURL}/generation/media_status.php?id=${jobId}`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      const statusData = await res.json();
      console.log("[Update Poll] Status:", statusData);

      if (statusData?.status === "completed") {
        setLoading(false);

        const videoUrl = encodeURIComponent(statusData.video_url);
        const newId = encodeURIComponent(jobId);
      const isEdited = encodeURIComponent(statusData.is_edited ?? 0);
        window.location.href = `/result?recordId=${newId}&videoUrl=${videoUrl}&edited=${isEdited}`;
        return;
      }

      if (
        statusData?.status === "failed" ||
        statusData?.status === "error"
      ) {
        setLoading(false);
        alert("Video generation failed. Please try again.");
        return;
      }

    } catch (err) {
      console.error("[Update Poll] Error:", err);
    }
  }

  setLoading(false);
  alert("Video is taking too long. Please check later.");
}


   // --------------------- Back Button --------------------- //
   const handleBack = () => {
    navigate(
      `/result?recordId=${encodeURIComponent(recordId)}&videoUrl=${encodeURIComponent(videoUrl)}`
    );
  };

  // --------------------- Render --------------------- //
  //if (loading) return <div className="loader">Loading...</div>;

const generateAIMedia = async () => {
  if (selectedMediaIndex === null) return;

  setLoading(true);
  setAiError("");

  try {
    const res = await fetch(
      `${config.baseURL}/generation/get_ai_image.php`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          id: recordId,
          prompt: aiPrompt.trim(),
          size
        })
      }
    );

    const data = await res.json();

    if (!res.ok || data.status !== "success") {
      throw new Error(data.message || "AI generation failed");
    }

    // ✅ show preview
    setAiPreviewUrl(data.image_url);

  } catch (err) {
    setAiError(err.message);

    setTimeout(() => {
      setShowAIModal(false);
      setAiError("");
      setAiPreviewUrl(null);
    }, 2000);

  } finally {
    setLoading(false);
  }
};


function applyAIReplace() {
  if (!aiPreviewUrl) return;

  const updated = [...mediaList];
  updated[selectedMediaIndex] = aiPreviewUrl;

  setMediaList(updated);
  setShowAIModal(false);
  setAiPreviewUrl(null);
  setAiPrompt("");
}

const closeAIModal = () => {
  setShowAIModal(false);
  setAiPrompt("");
  setAiError("");
  setAiPreviewUrl(null);
};

function closePexelsModal() {
  document
    .querySelectorAll(".modal_pexel video")
    .forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });

  setShowPexelsModal(false);
}



  if (error) return <div className="error">Error: {error}</div>;

  return (<>
    <div className='Edit-page'>
      
       
<LeftPanel/>
      <Loader show={loading} />
    <div className="edit-wrapper">

      <div className="edit-header">
        <button onClick={handleBack}>Back</button>
        <h2>Edit Video</h2>
        <button onClick={saveChanges} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </button>
        {/* <button
  onClick={() =>
    navigate("/preview", {
      state: {
        mediaList,
        music,
        musicType,
        uploadedMusicId,
        transitionStyle,
      },
    })
  }
>
  Preview
</button> */}

      </div>

      <div className="tabs">
        {["Media", "Music", "Script", "Settings"].map((tab) => (
          <div
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {renderTab()}

      {/* ---------------- PEXELS MODAL ---------------- */}
      {showPexelsModal && (
        <div className="modal-overlay-pexels" onClick={closePexelsModal}>
          <div className="modal_pexel" onClick={(e) => e.stopPropagation()}>
            <button
  className="modal-close"
 onClick={closePexelsModal}
>
  ✕
</button>

            <h3 className="model_pexel_title">Search Stock Media</h3>

            <div className="search-row">
            <div className="pexels-search-bar">
  <input
    type="text"
    placeholder="Enter keyword..."
    value={pexelsQuery}
    onChange={(e) => setPexelsQuery(e.target.value)}
  />

  <select
    value={pexelsType}
    onChange={(e) => setPexelsType(e.target.value)}
  >
    <option value="video">Video</option>
    <option value="image">Image</option>
  </select>

  <button onClick={searchPexels}>Search</button>
</div>

              <button className="search-row-search" onClick={applyPexelsReplace}>Replace</button>
            </div>

            {pexelsLoading && <div>Loading...</div>}

            <div className="pexels-grid">
              {pexelsResults.map((item) => (
            <div
  key={item.id}
  className={`pexels-item ${
    selectedPexelsItem?.id === item.id ? "selected" : ""
  }`}
  onClick={(e) => {
    setSelectedPexelsItem(item);

    const video = e.currentTarget.querySelector("video");
    if (video) {
      document.querySelectorAll(".pexels-video").forEach((v) => {
        if (v !== video) {
          v.pause();
          v.currentTime = 0;
        }
      });

      video.paused ? video.play() : video.pause();
    }
  }}
>
  {item.type === "video" ? (
    <video
      src={item.url}
      muted
      preload="metadata"
      playsInline
      className="pexels-video"
    />
  ) : (
    <img src={item.url} alt="" />
  )}

  <div className="pexels-check">✓</div>
</div>


              ))}
            </div>

          </div>
        </div>
      )}

    </div>

{/* ---------------- AI MEDIA MODAL ---------------- */}
{showAIModal && (
  <div className="modal-overlay">
    <div className="modal_ai">

      {/* ❌ Close button */}
      <button
        className="modal-close"
        onClick={closeAIModal}
      >
        ✕
      </button>

      <h3>Generate AI Image</h3>

      {/* 📝 PROMPT INPUT */}
      {!aiPreviewUrl && (
        <>
          <textarea
            placeholder="Describe the image you want..."
            value={aiPrompt}
            onChange={(e) => setAiPrompt(e.target.value)}
          />

          <button
  disabled={aiLoading || !aiPrompt.trim() || !size}
  onClick={generateAIMedia}
>
  Generate
</button>

        </>
      )}

      {/* ⏳ LOADER */}
     {loading && <Loader show={loading} />}


      {/* ❌ ERROR */}
      {aiError && <div className="error">{aiError}</div>}

      {/* 🖼️ PREVIEW + ACTIONS */}
      {aiPreviewUrl && (
        <div className="ai-preview">
          <img src={aiPreviewUrl} alt="AI Preview" />

          <div className="ai-actions">
            <button
              className="cancel"
              onClick={closeAIModal}
            >
              Cancel
            </button>

            <button
              className="replace"
              onClick={applyAIReplace}
            >
              Replace
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
)}
</div>
    </>
  );
  
};

export default EditPage;
